var path = '/templates/core/views/emptynav.html';
var html = "<div class=mainnav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/views/emptynav.html
// module id = 1373
// module chunks = 0